import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const generateChapters = async (orgId: string, recordingId: string) => {
  const response = await axiosClient.post(
    `/${orgId}/recordings/${recordingId}/generate-chapters`,
  );
  return response.data;
};

function useGenerateChapters(
  orgId: string,
  recordingId: string,
  options?: Partial<
    UseMutationOptions<void, HttpError, { orgId: string; recordingId: string }>
  >,
) {
  return useMutation({
    mutationFn: () => generateChapters(orgId, recordingId),
    mutationKey: ["generate-chapters", orgId, recordingId],
    ...options,
  });
}

export { useGenerateChapters };
